<template>
	<div v-if="isUserAllowedInLevel1">
		<BaseHeader :title="$t('admin_settings').toString()"></BaseHeader>
		<div class="main">
			<div v-if="!isLoading">
				<div class="flex flex-col">
					<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
							<div v-for="adminSetting in adminSystemSettings" :key="adminSetting.id">
								<BaseInput
									class="w-1/2"
									:label="adminSetting.label"
									:ref="'Textfield' + adminSetting.key"
									:required="true"
									type="text"
									v-model="adminSetting.value"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="flex flex-grow justify-center w-full opacity-75">
				<LoadingSpinner />
			</div>
			<Footer class="justify-between" :is-back-button="false" :is-continue-button="true">
				<template #continueButton>
					<SaveButton @click="save" class="btn-blue">
						{{ $t('general.save') }}
					</SaveButton>
				</template>
			</Footer>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import AdminSystemSettingsRepository from '@/api/repositories/AdminSystemSettingsRepository';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import Footer from '@/components/damagecases/Footer.vue';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';
import Validate from '@/mixins/Validate';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'AdminSystemSettings',
	components: { Forbidden, SaveButton, Footer, BaseInput, LoadingSpinner, BaseHeader },
	mixins: [Validate, Authentication],
	data() {
		return {
			isLoading: false,
			adminSystemSettings: null,
		};
	},
	mounted() {
		this.isLoading = true;
		this.getSystemSettings();
	},
	methods: {
		getSystemSettings() {
			new AdminSystemSettingsRepository()
				.getAll()
				.then(response => {
					this.adminSystemSettings = response.data.data;
					this.isLoading = false;
				})
				.catch(e => {
					this.isLoading = false;
					console.log(e);
				});
		},
		save() {
			if (this.validate()) {
				this.isLoading = true;
				new AdminSystemSettingsRepository()
					.updateAll(this.adminSystemSettings)
					.then(response => {
						this.$store.commit('setConfirmLeaving', false);
						this.$swal(this.$t('general.success').toString(), this.$t('general.changes_saved').toString(), 'success');
						this.isLoading = false;
					})
					.catch(e => {
						console.log(e);
						this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
						this.isLoading = false;
					});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
